import { APP_NAME } from '../utils/branding';
import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import BrandLogo from '../components/BrandLogo';

function Register() {
  const { register } = useAuth();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    role: 'user',
    acceptedLegal: false,
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || sessionStorage.getItem('pendingEventRedirect') || '';

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

    setFormData({
      ...formData,
      [e.target.name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (formData.password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }

    if (!formData.acceptedLegal) {
      setError("Vous devez accepter les Conditions d'utilisation et la Politique de confidentialité.");
      return;
    }

    setLoading(true);

    try {
      const result = await register(
        formData.name,
        formData.email,
        formData.password,
        formData.role,
        formData.acceptedLegal
      );
      if (!result.success) {
        setError(result.error || "L'inscription a échoué. Veuillez réessayer.");
        return;
      }

      if (from) {
        sessionStorage.removeItem('pendingEventRedirect');
        navigate(from, { replace: true });
      } else if (formData.role === 'user') {
        navigate('/profile-upload');
      } else {
        navigate('/photographer');
      }
    } catch (err) {
      setError(err.message || "L'inscription a échoué. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <div className="auth-container">
        <BrandLogo className="auth-brand-logo" />
        <h2>Créer votre compte {APP_NAME}</h2>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nom complet</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Saisissez votre nom complet"
            />
          </div>

          <div className="form-group">
            <label>E-mail</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Saisissez votre e-mail"
            />
          </div>

          <div className="form-group">
            <label>Je suis :</label>
            <select
              name="role"
              value={formData.role}
              onChange={handleChange}
              required
            >
              <option value="user">Participant / utilisateur</option>
              <option value="photographer">Photographe professionnel</option>
              <option value="event_manager">Organisateur d'événements</option>
            </select>
            <small style={{ color: 'var(--gray)' }}>
              Un organisateur crée des événements et confie chaque lot de photos
              au photographe qui les a prises.
            </small>
          </div>

          <div className="form-group">
            <label>Mot de passe</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Créez un mot de passe (min. 6 caractères)"
            />
          </div>

          <div className="form-group">
            <label>Confirmer le mot de passe</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              placeholder="Confirmez votre mot de passe"
            />
          </div>

          <label className="legal-consent">
            <input
              type="checkbox"
              name="acceptedLegal"
              checked={formData.acceptedLegal}
              onChange={handleChange}
              required
            />
            <span>
              J'accepte les <Link to="/terms">Conditions d'utilisation</Link> et la{' '}
              <Link to="/privacy">Politique de confidentialité</Link>.
            </span>
          </label>

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? 'Création du compte...' : 'Créer le compte'}
          </button>
        </form>

        <div className="auth-footer">
          Vous avez déjà un compte ? <Link to="/login">Connectez-vous ici</Link>
        </div>
      </div>
    </div>
  );
}

export default Register;
